<template>
    <div class="viewer position-fixed d-flex flex-column"
         @click="$emit('close')"
         v-if="media">
        <div class="d-flex justify-content-end flex-shrink-0">
            <b-icon-x @click="$emit('close')" class="text-white m-3" scale="2"/>
        </div>

        <div class="flex-grow-1 align-items-center justify-content-center d-flex" @click.stop="">
            <component
                    :is="media.mime_type.split('/')[0] + '-viewer'" :src="media.full_url"/>
        </div>

        <div class="flex-shrink-0 d-flex justify-content-start p-2 bar overflow-auto" v-if="mediaList">
            <template v-for="mediaObj in mediaList">
                <component :is="mediaObj.mime_type.split('/')[0] + '-thumbnail'"
                           :src="mediaObj.full_url"
                           class="mx-2"
                           height="64px"
                           width="64px"
                           @click.stop="$emit('change', mediaObj)"
                           :key="mediaObj.id"/>
            </template>
        </div>
    </div>
</template>

<script>
    import ImageViewer from "./MediaViewers/ImageViewer";
    import VideoViewer from "./MediaViewers/VideoViewer";
    import ApplicationViewer from "./MediaViewers/ApplicationViewer";
    import ApplicationThumbnail from "./MediaThumbnails/ApplicationThumbnail";
    import ImageThumbnail from "./MediaThumbnails/ImageThumbnail";
    import VideoThumbnail from "./MediaThumbnails/VideoThumbnail";

    export default {
        name: "Viewer",
        components: {
            ImageViewer,
            VideoViewer,
            ApplicationViewer,
            ApplicationThumbnail,
            ImageThumbnail,
            VideoThumbnail
        },
        props: {
            media: {
                type: Object,
            },
            mediaList: {
                type: Array
            }
        },
    }
</script>

<style scoped>
    .viewer {
        height: 100%;
        width: 100%;
        top: 0;
        right: 0;
        z-index: 9999;
        background-color: rgba(0, 0, 0, .82);
    }

    .bar {
        background-color: rgba(0, 0, 0, 0.92);
    }
</style>
